import React from 'react';
import KickImage from 'Reuseables/KickImage';
import styled from 'styled-components';
import propTypes from 'prop-types';
import Countdown from 'react-countdown-now';
import moment from 'moment';

import PendingIcon from '../../../../../images/icons/pending.png';
import ErrorIcon from '../../../../../images/icons/error.png';
import TimesUpIcon from '../../../../../images/icons/times-up.png';
import SuccessIcon from '../../../../../images/icons/success.png';

import VANumberPlaceholder from './VANumberPlaceholder';

const PaymentStatus = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem 0px;
  > p {
    margin: 0;
    &:first-child{
      font-weight: 700;
    }
  }
  img{
    width: 150px;
    height: 150px;
    padding: 1rem;
  }
  .span-countdown{
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: .5rem;
  }
`

const getHeaderText = (paymentStatus, isExpired) => {
  switch(paymentStatus) {
    case 'PENDING':
    case 'VERIFYING_BID': return isExpired? 'Your payment has been expired.' : 'Waiting your payment confirmation.';
    case 'VERIFYING_PAYMENT' : return 'Your payment is being processed by Admin.';
    case 'EXPIRED': return 'Your payment has been expired.';
    case 'COMPLETED': return 'Your payment has been paid successfully.';
    case 'REJECTED':
    case 'PENDING_REFUND':
    case 'REFUNDED':
    case 'CANCELLED': return 'Your payment has been cancelled.';
    default: return 'We got something issues when processing your payment.';
  }
}
const getStatusIcon = (paymentStatus, isExpired) => {
  switch(paymentStatus) {
    case 'PENDING':
    case 'VERIFYING_BID': return isExpired? TimesUpIcon : PendingIcon;
    case 'VERIFYING_PAYMENT' : return PendingIcon;
    case 'EXPIRED': return TimesUpIcon;
    case 'COMPLETED': return SuccessIcon;
    // case 'REJECTED':
    // case 'PENDING_REFUND':
    // case 'REFUNDED':
    // case 'CANCELLED': return ErrorIcon;
    default: return ErrorIcon;
  }
}

const getSelectedPayment = (paymentMethod, bankCode) => {
  switch(paymentMethod) {
    case 'virtual_account': return bankCode? `${bankCode} - Virtual Account` : 'Virtual Account';
    case 'credit_card': return 'Credit Card';
    case 'kredivo': return 'Kredivo';
    case 'full_wallet': return 'Kick Credit';
    default: return 'Bank Transfer';
  }
}

const PaymentStatusCard = props => {
  const expiredAtParsed = moment(props.expiredAt).toISOString();
  // const expiredAtParsed = moment().add(1, 'minutes').format('YYYY-MM-DD HH:mm:ss');
  return (
    <PaymentStatus>
      <p>{ getHeaderText(props.paymentStatus, props.isExpired) }</p>
      <KickImage src={getStatusIcon(props.paymentStatus, props.isExpired)} alt={`Payment Status - ${props.paymentStatus}`}/>
      {
        ['PENDING', 'VERIFYING_BID'].includes(props.paymentStatus) && !props.isExpired && props.expiredAt?
        <Countdown
          date={expiredAtParsed}
          renderer={({ hours, minutes, seconds, completed })=> (
            <span className="span-countdown">
              {completed? '00:00:00':`${hours}:${minutes}:${seconds}`}
            </span>
          )}
          onComplete={props.onExpired}
        />
        :null
      }
      <p>Payment using <strong>{getSelectedPayment(props.paymentMethod, props.bankCode)}</strong>.</p>
      {
        props.vaNumber?
          <VANumberPlaceholder vaNumber={props.vaNumber}/>
        : null
      }
    </PaymentStatus>
  )
}

export default PaymentStatusCard;

PaymentStatusCard.propTypes = {
  paymentStatus: propTypes.string,
  paymentMethod: propTypes.string,
  bankCode: propTypes.string,
  isExpired: propTypes.bool,
  vaNumber: propTypes.string
}